var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPiggyBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.537,
    height: 18.377,
    viewBox: "0 0 14.537 18.377",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9844",
    "data-name": "Group 9844",
    transform: "translate(505.913 -20237.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_9816927541582955602",
    "data-name": 9816927541582957000,
    transform: "translate(-520.204 20237.031)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1931",
    "data-name": "Path 1931",
    d: "M28.578,53.944l-.277-.1-.318-.116a4.921,4.921,0,0,1-.824-.514c-.635-.573-1.22-1.22-1.843-1.817a8.332,8.332,0,0,0-1.91-1.44,7.718,7.718,0,0,0-1.641-.626,2.685,2.685,0,0,1-3.605.075,5,5,0,0,0-3.62,4.478c0,.029,0,.059,0,.089a5.32,5.32,0,0,0,.638,2.767v0c.389,1.354.636,2.168,1.095,3.609H18.52c0-.443-.07-.917-.07-1.432a7.411,7.411,0,0,0,2.019.277h.005A12.474,12.474,0,0,0,22,59.152l.134.188.314.443c.1.151.2.3.3.44q.05.067.1.131h2.593L25.1,58.566a.243.243,0,0,1,.051-.04l.09-.032h.012a6.3,6.3,0,0,0,3.329-2.331Q28.578,55.052,28.578,53.944Zm-6.646-2.09h-4.02a.433.433,0,1,1,0-.866h4.02a.433.433,0,1,1,0,.866Z",
    transform: "translate(0 -41.464)",
    fill: "none",
    stroke: "#0077b6",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1932",
    "data-name": "Path 1932",
    d: "M38.852,19.691a2.25,2.25,0,1,0,2.25,2.25A2.25,2.25,0,0,0,38.852,19.691Z",
    transform: "translate(-18.93 -17.027)",
    fill: "none",
    stroke: "#db5f28",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1933",
    "data-name": "Path 1933",
    d: "M71.766,1.013A1.908,1.908,0,1,0,73.674,2.92a1.908,1.908,0,0,0-1.908-1.908Z",
    transform: "translate(-47.468)",
    fill: "none",
    stroke: "#db5f28",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiggyBank);
export default __webpack_public_path__ + "static/media/piggy_bank.d59153130d33df5e0c2ad5a07edcb5e9.svg";
export { ForwardRef as ReactComponent };